import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-deep-black shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo + Name */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/logo/Gujarat_APP_Association.jpg" 
              alt="APP Association" 
              className="h-10 w-auto sm:h-12"
            />
            <span className="text-gold text-xl sm:text-2xl font-bold hidden sm:block">
             APP Association
            </span>
            <span className="text-gold text-lg font-bold sm:hidden">
              APP Association
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className="text-white hover:text-gold font-medium transition-colors duration-300"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="text-white hover:text-gold font-medium transition-colors duration-300"
            >
              About Association
            </Link>
            <Link 
              to="/members" 
              className="text-white hover:text-gold font-medium transition-colors duration-300"
            >
              Association Members
            </Link>
            <Link 
              to="/gallery" 
              className="text-white hover:text-gold font-medium transition-colors duration-300"
            >
              Gallery
            </Link>
            <Link 
              to="/releases" 
              className="text-white hover:text-gold font-medium transition-colors duration-300"
            >
              Notification
            </Link>
            <Link 
              to="/contact" 
              className="text-white hover:text-gold font-medium transition-colors duration-300"
            >
              Contact Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsOpen(!isOpen)}
              className="text-gold focus:outline-none"
            >
              <svg 
                className="w-6 h-6" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4 border-t border-gold">
            <ul className="space-y-4 pt-4">
              <li>
                <Link 
                  to="/" 
                  className="block text-white hover:text-gold font-medium transition-colors duration-300 py-2"
                  onClick={() => setIsOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className="block text-white hover:text-gold font-medium transition-colors duration-300 py-2"
                  onClick={() => setIsOpen(false)}
                >
                  About Association
                </Link>
              </li>
              <li>
                <Link 
                  to="/members" 
                  className="block text-white hover:text-gold font-medium transition-colors duration-300 py-2"
                  onClick={() => setIsOpen(false)}
                >
                  Association Members
                </Link>
              </li>
              <li>
                <Link 
                  to="/gallery" 
                  className="block text-white hover:text-gold font-medium transition-colors duration-300 py-2"
                  onClick={() => setIsOpen(false)}
                >
                  Gallery
                </Link>
              </li>
              <li>
                <Link 
                  to="/releases" 
                  className="block text-white hover:text-gold font-medium transition-colors duration-300 py-2"
                  onClick={() => setIsOpen(false)}
                >
                  Releases
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="block text-white hover:text-gold font-medium transition-colors duration-300 py-2"
                  onClick={() => setIsOpen(false)}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;